// extracted by mini-css-extract-plugin
export default {"productGrid":"k0-z","centerLink":"l0-z","productSection":"m0-z","item":"n0-z","ctaButton":"o0-z"};